module.exports = __webpack_public_path__ + "img/sFwd.8fe9915a.svg";